module.exports = __webpack_public_path__ + "a4f8e7433b0dbd9ea2c1d21fccad75c2.jpg";